import { TimelineTextData } from "../../mock/timeline";
import { Text } from "../Text";

interface TimelineItemTextProps {
  data: TimelineTextData;
}

export const TimelineItemText: React.FC<TimelineItemTextProps> = ({ data }) => {
  const { weight = 700 } = data;
  return (
    <Text fontSize={`clamp(1.4rem, ${data.size}, 3.2rem)`} fontWeight={weight}>
      {data.content}
    </Text>
  );
};
